/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-18 11:01:35 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-03-04 10:49:00
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import Antd from 'ant-design-vue'
import router from './router/router'
import DatePicker from 'ant-design-vue/es/date-picker/moment';
import TimePicker from 'ant-design-vue/es/time-picker/moment';
import Calendar from 'ant-design-vue/es/calendar/moment';
import moment from 'moment-timezone';
import { notification } from 'ant-design-vue';
import '~/assets/images/svg/index.js';
import { COUNTRY_TIME_TZ } from './contants/common';

import artemisadsComponents from './artemisadsComponents'
import i18n from './i18n'
import './assets/less/common.less'
import './assets/less/antd-theme.less'
import './assets/iconfont/iconfont.js'
import Cooperators from '~/contants/cooperator.js'
// import "ant-design-vue/dist/antd.css"
const app = createApp(App);
const pinia = createPinia();

const localStoragePrefix = location.hostname;

// 检查是否有token、token是否过期
const checkUserStatus = () => {
  let isActive = true;
  const userToken = localStorage.getItem(`${localStoragePrefix}_userToken`);
  const tokenTime = Number(localStorage.getItem(`${localStoragePrefix}_tokenTime`));
  const timeNow = new Date().getTime();
  const expirationTime = 1000 * 60 * 60 * 24 * 3; //3天
  if (!userToken || (tokenTime + expirationTime <= timeNow)) {
    localStorage.setItem(`${localStoragePrefix}_userToken`, '');
    localStorage.setItem(`${localStoragePrefix}_tokenTime`, '');
    localStorage.setItem(`${localStoragePrefix}_artmisAdsUserInfo`, '');
    isActive = false;
  }
  return isActive;
}

function isCooperator(host) {
  const cooperatorName = host.replace(/^(\w+)\.[\w\.]*/, '$1')
  const cooperator = Cooperators[cooperatorName]

  return !!cooperator
}

/**
 * 判断当前用户有没有访问nextUrl的权限
 * @param {*} menus 
 * @param {*} nextUrl 
 * @returns 
 */
function checkUserPermission(menus, nextUrl) {
  // 不能设置permission的路由
  // 公共路由
  const publicPaths = [
    '/terms-of-service', '/privacy-policy',
    '/delegation-invitation', '/sign-up',
    '/sign-in', '/find-password',
    '/reset-password', '/profile'];
  // 不能设置permission的seller端路由
  const sellerPaths = ['/seller/connection', '/seller/pay-result', '/seller/referral','/seller/Settings/paidPlacement','/seller/Settings/paidPlacement/campaigns','/seller/Settings/paidPlacement/placement','/seller/Settings/paidPlacement/placement/:id','/seller/sellerAccount/authorization/guide','/seller/associateCentral/brands/setUpAssociatePartnership','/seller/associateCentral/setUpAssociatePartnership','/seller/associateCentral/setUpAssociatePartnershipMultiple','/seller/associateCentral/setUpAssociatePartnershipBrands','/seller/associateCentral/reports/brand','/seller/associateCentral/reports/performance','/seller/associateCentral/reports/product','/seller/associateCentral/reports/publisher',
    '/seller/creatorConnections/accCreact',
    '/seller/creatorConnections/accBonusProgram/view/:id'
  ];
  // 不能设置permission的publisher端路由
  const publisherPaths = ['/publisher/referral', '/publisher/settings/paidPlacement', '/publisher/settings/paidPlacement/campaigns', '/publisher/settings/paidPlacement/placement', '/publisher/settings/paidPlacement/campaigns/:id','/publisher/associateCentral/creatorConnections/allCampaigns',
    '/publisher/campaigns/details/:id',
    '/publisher/creatorConnections/programdetails/:id',
  ];
  // 需要正则匹配的路由
  const regPaths = [
    /^\/publisher\/products\/\d+/,
    /^\/publisher\/brands\/\d+/,
    /^\/publisher\/invoice-pdf\/[\w\d-]+/,
    /^\/seller\/invoice-pdf\/[\w\d-]+/,
    /^\/seller\/merge-pdf\/[\w\d-]+/,
    /^\/seller\/campaigns-invoice-pdf\/[\w\d-]+/,
    /^\/seller\/brand\/detail\/\d+/,
    /^\/seller\/product\/\d+/,
    /^\/seller\/publishers\/\d+/,
    /^\/seller\/cpc\/[\w\d-]+/i,
    /^\/seller\/creatorConnections\/[\w\d-]+/i,
    /^\/publisher\/campaigns\/details\/[\w\d-]+/i,
    /^\/publisher\/creatorConnections\/programdetails\/[\w\d-]+/i,
    /^\/seller\/associateCentral\/\d+/,
    /^\/help\//,
    /^\/publisher\/settings\/paidPlacement\/campaigns\/[\w\d-]+/i, 
    /^\/seller\/Settings\/paidPlacement\/campaigns\/[\w\d-]+/i, 
    /^\/seller\/Settings\/paidPlacement\/placement\/[\w\d-]+/i, 
    /^\/operator\/merge-pdf\/[\w\d-]+/,
    /^\/seller\/sellerAccount\/authorization\/guide\/[\w\d-]+/i,
  ];

  if (publicPaths.includes(nextUrl)) {
    return true;
  } else if (sellerPaths.includes(nextUrl) || publisherPaths.includes(nextUrl)) {
    return true;
  } else if (regPaths.some(reg => reg.test(nextUrl))) {
    return true;
  }

  if (menus) {
    return menus.some(item => {
      if (item.children) {
        return item.children.some(child => child.path === nextUrl);
      }

      return item.path === nextUrl;
    });
  }

  // 默认可访问
  return true;
}

function nextSignIn(next, to, userInfo) {
  const seller =
    to.path.startsWith('/seller') || userInfo?.userType === 'seller'
  next({
    path: '/sign-in',
    query: seller ? { seller: '1' } : {},
  })
}

const PROFILE_FORCE_ALLOW_PATHS = [
  '/profile',
  '/terms-of-service',
  '/privacy-policy',
  '/404',
  '/delegation-invitation',
]

router.beforeEach((to, from, next) => {
  if (to.meta?.titleKey) {
    document.title = i18n.global.t(to.meta.titleKey)
  } else if (to.meta?.title) {
    document.title = to.meta.title
  } else {
    document.title = 'Artemisads'
  }

  if (to.matched.length) {
    let userInfo = localStorage.getItem(`${localStoragePrefix}_artmisAdsUserInfo`);

    if (userInfo) {
      userInfo = JSON.parse(userInfo);
    } else {
      userInfo = {};
    }

    const shouldForceProfile =
      checkUserStatus() &&
      !PROFILE_FORCE_ALLOW_PATHS.includes(to.path) &&
      !/^\/help\//.test(to.path)

    // 未选择账号类型时，强制进入 profile 完成选择
    if (userInfo.status === 'PENDING_CHOOSE_TYPE' && shouldForceProfile) {
      next('/profile')
      return
    }

    // 需要绑定支付方式时，强制进入 profile 支付步骤
    if (userInfo.needBindPayment === 'Y' && shouldForceProfile) {
      sessionStorage.setItem(`${localStoragePrefix}_profileConnectingStep`, 'payment')
      next('/profile')
      return
    }

    let nextUrl = '';

    if ('/products' === to.path || /\/help/.test(to.path) || ['about', 'services', 'clients'].map(item => '/?point=' + item).indexOf(to.fullPath) != -1) {
      // 帮助中心、cooperator不需要登录验证
      next()
    } else if (isCooperator(location.host)) {
      next('/products')
    } else if (to.meta.requiresAUserType) { // 判断该路由是否需要进行鉴权
      if (to.meta.requiresAUserType === userInfo.userType) {
        const isActive = checkUserStatus();

        if (!isActive) {
          if (userInfo.userType === 'admin') {
            nextUrl = '/operation/login'
          } else {
            nextUrl = '/sign-in'
          }
        }
      } else {
        nextUrl = from.path;
      }

      if (nextUrl) {
        if (userInfo.menus && checkUserPermission(userInfo.menus.children, nextUrl)) {
          next(nextUrl);
        } else {
          if (to.path.startsWith('/operator')) {
            next();
          } else {
            localStorage.clear();
            nextSignIn(next, to, userInfo); // 没权限直接跳登录
          }
        }
      } else {
        if (userInfo.menus && checkUserPermission(userInfo.menus.children, to.path)) {
          next();
        } else {
          if (to.path.startsWith('/operator')) {
            next();
          } else {
            localStorage.clear();
            nextSignIn(next, to, userInfo); // 没权限直接跳登录
          }
        }
      }
    } else {
      // 公共路由, 不需要进行鉴权
      if (['/404', '/delegation-invitation', '/terms-of-service', '/privacy-policy'].includes(to.path)) {
        next();
        return;
      }

      // 帮助中心路由, 不需要进行鉴权
      if (/^\/help\//.test(to.path)) {
        next();
        return;
      }

      if (to.path === '/profile') {
        next();
        return;
      }

      if (from.path === '/' && userInfo.userType && userInfo.reviewStatus !== 'Rejected') {
        if (userInfo.userType === 'publisher') {
          if (userInfo.reviewStatus === 'Rejected') {
            nextUrl = '/profile'
          } else {
            nextUrl = '/publisher/dashboard'
          }
        } else if (userInfo.userType === 'seller') {
          nextUrl = '/seller/dashboard'
        } else {
          nextUrl = '/operator/users'
        }
      }

      if (from.path === '/' && userInfo.reviewStatus === 'Rejected' && to.path != '/profile') {
        nextUrl = '/profile'
      }

      if (nextUrl) {
        next(nextUrl);
      } else {
        next(); // 不需要进行鉴权，直接进行下一步路由
      }
    }
  } else {
    next('/404');
  }
});

notification.config({
  placement: 'bottomRight',
  bottom: '50px',
  duration: 3,
  rtl: true,
});

// 设置时区
let defaultCountry = 'US';
let userInfoData = localStorage.getItem(`${localStoragePrefix}_artmisAdsUserInfo`);
if (userInfoData) {
  userInfoData = JSON.parse(userInfoData);
  defaultCountry = userInfoData.countryCode || 'US';
}
moment.tz.setDefault(COUNTRY_TIME_TZ[defaultCountry]);

app.config.productionTip = false;
app.use(i18n).use(router).use(Antd).use(DatePicker).use(TimePicker).use(Calendar).use(pinia).use(artemisadsComponents).mount('#app');

